import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';

@Component({
  selector: 'app-mostusedtemplateswidget',
  templateUrl: './mostusedtemplateswidget.component.html',
  styleUrls: ['./mostusedtemplateswidget.component.scss'],
   encapsulation: ViewEncapsulation.None
})
export class MostusedtemplateswidgetComponent implements OnInit {
  public fetchMostUsedTemplates$ = this.dashboardFacade$.mostUsedTemplates$;
  constructor(private dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchMostUsedTemplates()
  }
}